import { useLocation } from '@/router/navigation'

function getNumericRouteStateValue(state: unknown, key: 'startStep' | 'limitToStep') {
  const routeState =
    typeof state === 'object' && state !== null ? (state as Record<string, unknown>) : null

  return routeState && typeof routeState[key] === 'number' ? routeState[key] : null
}

export function useSelfEnrollmentRouteState() {
  const location = useLocation()

  const initialStep = getNumericRouteStateValue(location.state, 'startStep')
  const limitToStep = getNumericRouteStateValue(location.state, 'limitToStep')

  return {
    initialStep,
    limitToStep
  }
}
